import { ReactNode } from 'react';

import { useInsightDetailMode } from './insight-detail-mode.context';
import { InsightOpenDetailButton } from './insight-open-detail-button.component';

export interface InsightDetailChromeProps {
    insightId: string;
    children: ReactNode;
    className?: string;
}

/**
 * Wraps non-InsightCard widgets (StatisticsCard, etc.) with a top-left open-detail button
 * without making the whole widget navigate on click.
 * Child root gets left padding so titles are not covered by the absolutely positioned button.
 */
export const InsightDetailChrome = ({ insightId, children, className }: InsightDetailChromeProps) => {
    const isDetailMode = useInsightDetailMode();

    if (isDetailMode) {
        return <div className={`h-full w-full min-w-0 ${className ?? ''}`}>{children}</div>;
    }

    return (
        <div className={`relative h-full w-full min-w-0 ${className ?? ''}`}>
            <div className='absolute top-3 left-3 z-10'>
                <InsightOpenDetailButton insightId={insightId} />
            </div>
            {/* ps-14 clears the size-9 button at left-3; ! overrides card p-4 */}
            <div className='h-full min-w-0 [&>*]:!ps-14'>{children}</div>
        </div>
    );
};
